"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segment = Segment;
const react_1 = __importDefault(require("react"));
function Segment({ highlight, children }) {
    return highlight ? react_1.default.createElement("mark", null, children) : react_1.default.createElement("span", null, children);
}
exports.default = Segment;
